// eslint-disable-next-line import/prefer-default-export
export const LOCATION_MODULES = {
  REGISTRATION: "registration",
  CIF: "registration_cif",
  FULL_MAP: "fullmap",
  DIRECTIONS: "directions",
  PERSONALIZATION_AI: "virtual_tour_ai",
  SEARCH_AI: "virtual_tour_search_ai",
};

export const MEDIA_TYPES = {
  PHOTO: "photo",
  VIDEO: "video",
  PANO: "pano",
  PANORAMA: "panorama",
  STOP_DESCRIPTION: "stop_description",
};

export const NETWORK_TYPES = {
  instagram: "instagram",
};
